// Format of a data-set value sent to Revit, e.g. "02 » Superstructure • 02.10 » Frame"
export const DATA_SET_CODE_SEPARATOR = " » ";
export const DATA_SET_LEVEL_SEPARATOR = " • ";

// Revit stores a data-set value as a property named after the data-set with this prefix, in this section
export const DATA_SET_PROPERTY_PREFIX = "BM_";
export const DATA_SET_PROPERTY_SECTION = "Other";
